// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "Keys";
import baseQueryWithReauth from "./requestInterceptor";

// Define a service using a base URL and expected endpoints

// const baseQuery = fetchBaseQuery({ baseUrl: keys.baseUrl });

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getAnalytics: builder.query({
      query: ({ token, id, dataPoint, parameters }) => ({
        url: `aggregation/${id}?parameter=${dataPoint}${parameters}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
    // The caller tenant's effective analytics granularity modes (dynamic bucket
    // modes). Returns { payload: { tenant, modes: ["hourly","daily","4h",...] } }.
    // Sourced from the tenant license; drives the rolling-rule + chart selectors.
    getAnalyticsModes: builder.query({
      query: ({ token }) => ({
        url: `aggregation/modes`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),
    getEnumerationAnalytics: builder.query({
      query: ({ token, id, dataPoint, parameters }) => ({
        url: `monitoring/getDataWrtService/${id}?dataPoint=${dataPoint}${parameters}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
    getServiceAnalytics: builder.query({
      query: ({ token, id, dataPoint, parameters }) => ({
        url: `aggregation/getAggregated/${id}?dataPoint=${dataPoint}${parameters}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
    getGroupAnalytics: builder.query({
      query: ({ token, parameters }) => ({
        url: `aggregation/aggregatedGroups/` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),
    getGroupInfo: builder.query({
      query: ({ token, id, parameters }) => ({
        url: `aggregation/${id}/getAggregatedDatabyGroupId/` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),
    getGroupChildAnalytics: builder.query({
      query: ({ token, parameters }) => ({
        url: `aggregation/aggregatedGroupsWithChildren/` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),
    getAggregatedDatabyGroupId: builder.query({
      query: ({ token, id, group_id, params }) => {
        let url = `/aggregation/${id}/getAggregatedDatabyGroupId/${params}`;
        if (parseInt(group_id)) {
          url += "&groupId=" + group_id;
        }

        return {
          url: url,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        };
      },
    }),
    getAggregatedDeviceDatabyGroupId: builder.query({
      query: ({ token, id, group_id, params }) => {
        let url = `/aggregation/getAggregatedDeviceDatabyGroupId/${id}/${params}`;
        if (parseInt(group_id)) {
          url += "&groupId=" + group_id;
        }

        return {
          url: url,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        };
      },
    }),
    getAggregatedMultipleGroupsWithChildren: builder.query({
      query: ({ token, id, parameters }) => ({
        url: `aggregation/aggregatedMultipleGroupsWithChildren/${id}` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),

    getGroupAggregatedReading: builder.query({
      query: ({ token, id, parameters }) => ({
        url: `aggregation/groupAggregatedReading/${id}` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),

    getGroupAggregatedSingleParameterReading: builder.query({
      query: ({ token, id, parameters }) => ({
        url: `aggregation/groupAggregatedSingleParameterReading/${id}` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),

    getGroupAggregatedMultipleParameterReading: builder.query({
      query: ({ token, id, parameters }) => ({
        url: `aggregation/groupAggregatedMultipleParameterReading/${id}` + parameters,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      keepUnusedDataFor: 900,
    }),
    
  }),
});
export const {
  useGetAnalyticsQuery,
  useGetAnalyticsModesQuery,
  useGetEnumerationAnalyticsQuery,
  useGetServiceAnalyticsQuery,
  useGetGroupAnalyticsQuery,
  useGetGroupChildAnalyticsQuery,
  useGetGroupInfoQuery,
  useGetAggregatedDatabyGroupIdQuery,
  useGetAggregatedDeviceDatabyGroupIdQuery,
  useGetAggregatedMultipleGroupsWithChildrenQuery,
  useGetGroupAggregatedReadingQuery,
  useGetGroupAggregatedSingleParameterReadingQuery,
  useGetGroupAggregatedMultipleParameterReadingQuery,
} = analyticsApi;
